import React from 'react';
import './Footer.css';
import Typography from '@material-ui/core/Typography';

function Footer () {

    const monthArray = [
        "January", 
        "February",
        "March", 
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",        
    ]
    
    const docUpdated = new Date(document.lastModified),
        date = docUpdated.getDate() + ' ' + monthArray[docUpdated.getMonth()] + ' ' + docUpdated.getFullYear();

    return (
        <div className="footer">
            <Typography variant="caption" display="block" style={{marginBottom:20}}>This calculator was designed and developed by the Clinical Skills Development Service.</Typography>
            <Typography variant="caption" display="block">Last updated {date}</Typography>
        </div>
    )
}

export default Footer;